import { useAuth } from "#/src/components/general";

export const useGetWorkOrderTypes = ({ includeSystem = false } = {}) => {
  const { user } = useAuth();

  return user?.oem?.ticketTypes?.filter(
    (type) => includeSystem || !type?.isSystem,
  );
};
